import { render, staticRenderFns } from "./VisitReason.vue?vue&type=template&id=ff1747dc&"
import script from "./VisitReason.vue?vue&type=script&lang=js&"
export * from "./VisitReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports